import Summary_1 from "./Designs/Summaries/Summary_1";
import Summary_1_Right from "./Designs/Summaries/Summary_1_Right";
import Summary_2 from "./Designs/Summaries/Summary_2";
import Summary_2_Right from "./Designs/Summaries/Summary_2_Right";
import Summary_LoadingBar from "./Designs/Summaries/Summary_LoadingBar";
import Summary_LoadingBar_Right from "./Designs/Summaries/Summary_LoadingBar_Right";
import Detail_1 from "./Designs/Details/Detail_1";
import Detail_2 from "./Designs/Details/Detail_2";
import Detail_3 from "./Designs/Details/Detail_3";
import Detail_4 from "./Designs/Details/Detail_4";
import Detail_5 from "./Designs/Details/Detail_5";
import Detail_LoadingBar from "./Designs/Details/Detail_LoadingBar";
import MonoText from "./Designs/Monos/MonoText";
import DualText from "./Designs/Duals/DualText";
import TestScaleDesign_1 from "./Designs/TestScaleDesign_1";
import AnsweringTendencyDesign_1 from "./Designs/CalculatedTendencies/AnsweringTendencyDesign_1";
import { designTypesEnum } from "../../../../../Helpers/EnumHelper";

import EmptySpace from "./HtmlElements/EmptySpace";
import MonoSpace from "./HtmlElements/MonoSpace";
import DualSpace from "./HtmlElements/DualSpace";
import ImageSpace from "./HtmlElements/ImageSpace";
import { HandleTestScore, NormalizeScore } from "../../../../../Helpers/ScoreNormalizationHelper";
import Summary_Scaleless_2 from "./Designs/Summaries/Summary_Scaleless_2";
import Summary_Scaleless_1 from "./Designs/Summaries/Summary_Scaleless_1";
import Summary_2_Header from "./Designs/Summaries/Summary_2_Header";
import Summary_Scoreless_Header from "./Designs/Summaries/Summary_Scoreless_Header";
import Summary_Scoreless_Header_Small from "./Designs/Summaries/Summary_Scoreless_Header_Small";
import MonoText_Frameless from "./Designs/Monos/MonoText_Frameless";
import MonoText_Frameless_H from "./Designs/Monos/MonoText_Frameless_H";
import Detail_CircleBar from "./Designs/Details/Detail_CircleBar";
import Detail_LoadingBar_Short from "./Designs/Details/Detail_LoadingBar_Short";
import Detail_Ozo from "./Designs/Details/Detail_Ozo";
import Detail_Ozo_Inline from "./Designs/Details/Detail_Ozo_Inline";
import Detail_Ozo_Circle from "./Designs/Details/Detail_Ozo_Circle";
import Detail_Ozo_Inline_Circle from "./Designs/Details/Detail_Ozo_Inline_Circle";
import Detail_Ozo_Loading_Bar from "./Designs/Details/Detail_Ozo_Loading_Bar";
import Detail_Ozo_Badge_Bar from "./Designs/Details/Detail_Ozo_Badge_Bar";
import Detail_Textual from "./Designs/Details/Detail_Textual";
import Detail_Textual_PBar from "./Designs/Details/Detail_Textual_PBar";
import Summary_Ten_Scale from "./Designs/Summaries/Summary_Ten_Scale";
import Detail_Textual_10_scale from "./Designs/Details/Detail_Textual_10_scale";
import Detail_Textual_L_Bar from "./Designs/Details/Detail_Textual_L_Bar";
import Summary_L_Bar from "./Designs/Summaries/Summary_L_Bar";
import Summary_L_Bar_Thin from "./Designs/Summaries/Summary_L_Bar_Thin";

export const SelectPdfReportItemDesign = (item, type, i, isForHeightCalculation) => {
  const designs = {
    Summary_1,
    Summary_2,
    Summary_LoadingBar,
    Detail_1,
    Detail_2,
    Detail_3,
    Detail_4,
    Detail_5,
    Detail_LoadingBar,
    MonoText,
    DualText,
    AnsweringTendencyDesign_1,
    TestScaleDesign_1,
    Summary_Scaleless_1,
    Summary_Scaleless_2,
    Summary_2_Header,
    Summary_Scoreless_Header,
    Summary_Scoreless_Header_Small,
    MonoText_Frameless,
    MonoText_Frameless_H,
    Summary_1_Right,
    Summary_2_Right,
    Summary_LoadingBar_Right,
    Detail_CircleBar,
    Detail_LoadingBar_Short,
    Detail_Ozo,
    Detail_Ozo_Inline,
    Detail_Ozo_Circle,
    Detail_Ozo_Inline_Circle,
    Detail_Ozo_Loading_Bar,
    Detail_Ozo_Badge_Bar,
    Detail_Textual,
    Detail_Textual_PBar,
    Summary_Ten_Scale,
    Detail_Textual_10_scale,
    Detail_Textual_L_Bar,
    Summary_L_Bar,
    Summary_L_Bar_Thin,
  };

  const isSub = item.subScopeId ? true : false;

  const GetNameProperty = (item) => {
    for (var name in designTypesEnum) {
      var value = designTypesEnum[name];
      if (value === item.designType) return name;
    }
  };

  const renderSwitch = (item) => {
    switch (item.componentName) {
      case "EmptySpace":
        return <EmptySpace key={i} item={item} />;
      case "MonoSpace":
        return <MonoSpace key={i} item={item} />;
      case "DualSpace":
        return <DualSpace key={i} item={item} />;
      case "ImageSpace":
        return <ImageSpace key={i} item={item} />;
      default:
        return CreateDynamicComponent(item);
    }
  };

  const CreateDynamicComponent = (item) => {
    if (type === "test" && item.scales) HandleTestScore(item.scales, item.score);
    else if (type === "test" && !item.scales) HandleTestScore(item.scale?.ranges, item.score);
    else if (type === "inventory" && item.componentName !== "AnsweringTendencyEntity") NormalizeScore(item);

    const SpecificComponent = designs[GetNameProperty(item)];
    return <SpecificComponent key={i} item={item} isSub={isSub} isForHeightCalculation={isForHeightCalculation} />;
  };

  return renderSwitch(item);
};
